import React, { Component } from 'react'
import { fileKey } from '../../../../../util/file_url'
import PDFDisplay from "../AttachmentsDisplay/PDFDisplay"
import PhotoViewer from "./PhotoViewer"
import AudioPlayer from "./AudioPlayer"
import VideoPlayer from "./VideoPlayer"
import {isEqual} from "lodash"
import { audioExtensions, imageExtensions, videoExtensions, documentExtensions } from '../../../../Templates/data'

export default class FileViewer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            viewingFile: false,
        }
    }

    toggleViewer = (event, file) => {
        event.stopPropagation()
        let path = fileKey(file)
        this.setState(prevState => ({
            viewingFile: path
        }))
    }

    render() {
        const files = this.props.files.map(file => (
            <li className="clickable" onClick={(event) => this.toggleViewer(event, file)} 
            key={file.path} style={{display: "flex", justifyContent: "space-between", width: "6.5em"}}>{file.path.split(`\\`).pop()}
            </li>
        ))
        const fileTypes = this.props.fileTypes
        if (isEqual(imageExtensions, fileTypes)) {
            return <PhotoViewer files={this.props.files} WIID={this.props.workInstructionId} deleteFile={this.deleteFile}/>
        } else if (isEqual(videoExtensions, fileTypes)) {
            return <VideoPlayer files={this.props.files} WIID={this.props.workInstructionId} deleteFile={this.deleteFile}/>
        } else if (isEqual(audioExtensions, fileTypes)) {
            return <AudioPlayer files={this.props.files} WIID={this.props.workInstructionId} deleteFile={this.deleteFile}/>
        } else if(isEqual(documentExtensions)) {
            return <div className={this.state.viewingFile ? "flex" : "flex-justify-center"} id="file-list-container">
                     <div style={{ margin: "1em", display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h3>{`Available ${this.props.fileTypes[0].toUpperCase()}s:`}</h3>
                        <ul style={{ margin: "1em", listStyle: "none", display: "flex", justifyConten: "center" }}>{files}</ul>
                    </div>
                    {this.state.viewingFile ? <PDFDisplay filename={this.state.viewingFile}/> : null}
                </div>
        }else {
            window.alert("Unable to preview file from step content. If you are attempting to view a 3d model, please set it as a default attachment.")
        }
    }
}